import client from "./client";

const getLocations = () => client.get("/locations");
const addLocation = (name, description, maxItems) => client.post("/locations/", { name, description, maxItems });
const deleteLocation = (location) => client.post("/locations/deleteLocation", { location });
const removeItem = (itemID) => client.post("/locations/removeItem", { itemID });
const lookupItems = (items) => client.post("/locations/lookupItems", { items });
const addItem = (itemID, locationID) => client.post("/locations/addItem", { itemID, locationID });
export default {
    getLocations,
    addLocation,
    deleteLocation,
    removeItem,
    addItem,
    lookupItems,
};
